export default {
  登录: "登录",
  "请输入工号！": "请输入工号！",
  请输入工号: "请输入工号",
  "请输入密码！": "请输入密码！",
  请输入密码: "请输入密码",
  "7天免登录": "7天免登录",
  "忘记密码？": "忘记密码？",
  登录按钮: "登录",
  首次登录提示: "首次登录密码为：123456， 登录后请尽快修改密码！",
};
